import React from 'react';
import MainMenu from '../MainMenu/MainMenu';

export default class Header extends React.Component {
  public render() {
    return (
      <header className="h-20 relative z-[100] w-full lg:h-24 left-0 top-0">
        <MainMenu />
      </header>
    );
  }
}
